var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['logo', _vm.getMenuState && _vm.getMobile ? 'logo--disable' : '', _vm.getRouteLeave ? 'logo--leave' : '']
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('h1', [_vm._v("LÉO ARNAUD")])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d4f6b3d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/common/header/Logo.vue
// module id = Sntq
// module chunks = 1